//#region Libraries
import CardLinkItemV2 from "components/CardLinkItem/secondary/CardLinkItemV2";
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin: 40px 0;
    justify-content: center;
    align-items: center;
    /* Restando a la altura mínima margin-top y margin-bottom */
    min-height: calc(var(--min-height-without-header) - 40px*2);
`;
export const CardLinkWrapper = styled.section`
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
    margin: 0 15px;
`;
export const ResourceCardLinkItem = styled(CardLinkItemV2)`
    &.secondary {
        width: 270px;
        height: 120px;
    }
`;